var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"h-full w-full overflow-y-auto"},[_vm._t("default")],2):_c('div',{staticClass:"h-full w-full overflow-y-auto flex justify-center items-center"},[_vm._v(" Indlæser.. ")])}
var staticRenderFns = []

export { render, staticRenderFns }